import { useSelector } from 'react-redux';
import { useLocale } from '../contexts/LocaleContext';
import { centsToDollarsNumber } from '../lib/util/money';
import * as types from '../types';
import { FREE_TRIAL_SHIPPING_CODE } from '../types/Product';

/**
 * Returns the localized price for free trial shipping from the shipping options config.
 * This hook looks at ALL shipping options (not just available ones) to get the configured
 * price for free trial shipping.
 *
 * @returns The formatted price string (e.g., "$8.99" for USD or "CA$12.00" for CAD), or null if not found
 */
export default function useFreeTrialShippingPrice(): string | null {
  const { currency, currencyFormatter } = useLocale();
  const shippingOptions = useSelector((state: types.AppState) => state.config.shippingOptions);

  const freeTrialShippingOption = shippingOptions.find((option) => option.code === FREE_TRIAL_SHIPPING_CODE);

  // not priced in every currency; a missing price must not throw, since every cart render reads this
  const priceInCents = freeTrialShippingOption?.pricingInCents[currency];
  if (priceInCents === undefined || priceInCents === null) {
    return null;
  }

  return currencyFormatter.format(centsToDollarsNumber(priceInCents));
}
